import Swiper from "swiper/bundle";

const CardsSliderAutoFour = () => {
  const autoCardsSliders = [...document.querySelectorAll('.slider-section__slider.auto-four-slides')];

  const initializeSlider = () => {
    autoCardsSliders.forEach((autoCardsSlider) => {
      const slides = [...autoCardsSlider.querySelectorAll('.swiper-slide')];
      const controls = autoCardsSlider.querySelector(".swiper-controls");

      const minSlidesForTabletMobile = 2;
      const minSlidesForDesktop = 4;

      const shouldInitializeSlider = (window.innerWidth >= 1024 && slides.length > minSlidesForDesktop) ||
                                     (window.innerWidth < 1024 && slides.length > minSlidesForTabletMobile);
      
      if (!shouldInitializeSlider) {
        if (controls) {
          controls.classList.add("d-none");
        }
      }

      if (shouldInitializeSlider) {
        if (controls) {
          controls.classList.remove("d-none");
        }

        const autoCardsCarousel = new Swiper(autoCardsSlider, {
          slidesPerView: 'auto',
          loop: true,
          scrollbar: {
            el: '.swiper-scrollbar',
          },
          navigation: {
            nextEl: '.swiper__button-next',
            prevEl: '.swiper__button-prev',
          },
        });
      }
    });
  };

  initializeSlider();

  window.addEventListener('resize', () => {
    autoCardsSliders.forEach((autoCardsSlider) => {
      const swiperInstance = autoCardsSlider.swiper;
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
      }
    });
    initializeSlider();
  });
}

export default CardsSliderAutoFour;

